import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {SessionGuard} from './providers/guards/session.guard';
import {LoggedInGuard} from './providers/guards/logged-in.guard';


const routes: Routes = [
  {
    path: '',
    canActivate: [
      SessionGuard
    ],
    loadChildren: () => import('./layout/private/private.module').then(m => m.PrivateModule)
  },
  {
    canActivate: [
      LoggedInGuard
    ],
    path: '',
    loadChildren: () => import('./layout/public/public.module').then(m => m.PublicModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
